import { render, staticRenderFns } from "./AssetModel.vue?vue&type=template&id=57a17a62&scoped=true&"
import script from "./AssetModel.vue?vue&type=script&lang=js&"
export * from "./AssetModel.vue?vue&type=script&lang=js&"
import style0 from "./AssetModel.vue?vue&type=style&index=0&id=57a17a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a17a62",
  null
  
)

export default component.exports